export { default } from './MapMetadata';
